import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';
import { Customer } from 'src/app/models/customer';
import { CustomerService } from 'src/app/services/customer.service';
import { SimpleCadCustomerComponent } from './simple-cad-customer/simple-cad-customer.component';
import Swal from 'sweetalert2';
import { Sling } from 'src/app/models/sling';
import { ProductCategoryType } from 'src/app/models/enums/product-category-type';
import { SlingService } from 'src/app/services/sling.service';
import { Conta, MarinaOrder, OrderItem, OrderQuota, SlingConfig } from 'src/app/models';
import { ToastService } from 'src/app/services/toast.service';
import { OperationalConfigService } from 'src/app/services/config/operational-config.service';
import { MessageUtil } from 'src/app/utils/message.util';
import { Router } from '@angular/router';
import { MarinaOrderService } from 'src/app/services/marina-order.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { OrderIssCityTaxRequestDTO } from 'src/app/models/dtos/order-iss-city-tax-requestDTO';
import { NgxSpinnerService } from 'ngx-spinner';
import { WebSocketService } from 'src/app/services/web-socket.service';
import { InvoicePaidService } from 'src/app/services/invoice-paid.service';
import { StorageUtil } from 'src/app/utils/storage.util';
import { InvoicePaid } from 'src/app/models/invoice-paid';
import { SalesStatesService } from './split-bill/sales-states.service';
import { SelectorBoatDTO } from 'src/app/models/dtos/selector-boat-DTO';
import { BoatSingleOrderParams, StandardPaymentConfig } from './split-bill/sales-interfaces';
import { PackageServiceService } from 'src/app/services/package-service.service';
import { PackageServiceBalanceDTO } from 'src/app/models/dtos/package-service-balance-DTO';
import { TipoFormaPagamento } from 'src/app/models/finance/tipo-forma-pagamento';
import { PrintingService } from 'src/app/services/printing-service';
import { OptionPrintQuestionTotem } from 'src/app/models/enums/option-print-question-totem';
import { PackageBalanceChangesModalComponent, PackageChangeDetail } from 'src/app/components/modals/package-balance-changes-modal/package-balance-changes-modal.component';
import { PrintType } from 'src/app/models/enums/print-type';
import { NotaFiscalService } from "../../../../services/nota-fiscal.service";
import * as dayjs from 'dayjs';
import { environment } from 'src/environments/environment';
import { Currency } from 'src/app/models/enums/currency';
import { CurrencyService } from 'src/app/services/currency.service';
import { CurrencyUtil } from 'src/app/utils/currency.util';
import { InvoiceEmailAttachmentType } from 'src/app/models/enums/invoice/invoice-email-attachment-type';

@Component({
  selector: 'app-sales-checkout-wizard',
  templateUrl: './sales-checkout-wizard.component.html',
  styleUrls: ['./sales-checkout-wizard.component.scss']
})
export class SalesCheckoutWizardComponent {

  @ViewChild(SimpleCadCustomerComponent, { static: false })
  simpleCadCustomer: SimpleCadCustomerComponent;

  activeIndex: number = 0;

  requiresCustomerIdentification: boolean = false;

  showQuota: boolean = false;
  showPaymentOptions: boolean = false;
  showNewCad: boolean = false;
  showAdvancedPayment: boolean = false;

  isSingleOrder: boolean = false;
  isSplitBill: boolean = false;
  isNixPix: boolean = false;
  isFirstDiscount: boolean = true;
  isFirstIssCityTax: boolean = true;
  isCanceled: boolean = false;
  isError: boolean = false;

  enablePayment: boolean = false;
  hasEnded: boolean = false;

  showSuccessModal: boolean = false;
  documentUrl: string = '';

  sling: Sling;

  slingConfig: SlingConfig;
  standardPaymentConfig: StandardPaymentConfig;
  isMovement: boolean;
  observation: string = '';

  validCustomerSelected: boolean = false;
  validSplitBillItems: boolean = true;

  customers: Customer[] = [];
  selectedBoat: SelectorBoatDTO;
  selectedCustomer: Customer = new Customer();
  serviceDeskCustomer: Customer = new Customer();

  orderedItems: OrderItem[];
  ownersQuota: OrderQuota[] = [];
  orderNumber: number = 0;
  invoiceNumber: number = 0;
  ownerOrderQuotas: OrderQuota[];
  discount: number = 0;
  paymentMethod: TipoFormaPagamento;
  account: Conta;
  issCityTax: number;
  issCityTaxValue: number = 0;
  total: number;

  invoice: any = null;
  payments: any[] = [];

  private _boatSingleOrderParams: BoatSingleOrderParams;
  previousBoatId: number = null;
  pendingValue: number = 0;
  maxPendingValue: number = 0;
  hasNFConsumer: boolean = false;
  currentCurrency: Currency = Currency.BRL;

  get unitValueFormat(): string {
    return this.currentCurrency === Currency.BRL ? '1.2-2' : '1.2-3';
  }

  packageServiceBalance: PackageServiceBalanceDTO[] = [];
  loadingPackageBalance: boolean = false;

  packageChangesDetails: PackageChangeDetail[] = [];
  constructor(
    private cdr: ChangeDetectorRef,
    private webSocketService: WebSocketService,
    private invoiceService: InvoiceService,
    private invoicePaidService: InvoicePaidService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private marinaOrderService: MarinaOrderService,
    private customerService: CustomerService,
    private messageUtil: MessageUtil,
    private slingService: SlingService,
    private toasty: ToastService,
    private config: DynamicDialogConfig,
    public dialog: DynamicDialogRef,
    private dialogService: DialogService,
    private operationalConfigService: OperationalConfigService,
    private salesStatesService: SalesStatesService,
    private notaFiscalService: NotaFiscalService,
    private printingService: PrintingService,
    private currencyService: CurrencyService,
    private packageServiceService: PackageServiceService
  ) {
    this.operationalConfigService.isMovements().then((isMovement: boolean) => {
      this.isMovement = isMovement;
    })
    this.operationalConfigService.hasNFConsumer().then((hasNFConsumer: boolean) => {
      this.hasNFConsumer = hasNFConsumer;
      console.log(this.hasNFConsumer);
    })
  }

  ngOnInit(): void {
    this.currentCurrency = this.currencyService.getCurrentCurrency();
    this.orderedItems = this.config.data.orderedItems;
    console.log(this.orderedItems);
    console.log(this.config.data);
    this.total = this.config.data.total;
    this.slingConfig = this.config.data.slingConfig;
    this.observation = this.config.data.observation || '';
    this.showAdvancedPayment = this.slingConfig.showAdvancedPayment;
    this.standardPaymentConfig = {
      accountId: this.config.data.slingConfig.accountId,
      accountName: this.config.data.slingConfig.accountName,
      paymentMethodId: this.config.data.slingConfig.paymentMethodId,
      paymentMethodName: this.config.data.slingConfig.paymentMethodName,
    }
    this.account = this.config.data.slingConfig.accountId;
    this.paymentMethod = this.config.data.slingConfig.paymentMethodId;
    this.issCityTax = this.config.data.slingConfig.cityTax;
    this.requiresCustomerIdentification = this.config.data.requiresCustomerIdentification;

    if (!this.requiresCustomerIdentification) {
      this.continueAsSingleOrder();
    }
    this.loadParams();
    this.pendingValue = this.getTotal();
    this.maxPendingValue = this.getTotal();
    this.salesStatesService.setSalesConfig(this.slingConfig);
  }


  loadParams(): void {
    this.boatSingleOrderParams = {
      customerId: this.config.data.params.customerId,
      boatId: this.config.data.params.boatId,
      slingId: this.config.data.params.slingId,
    };
  }

  onBoatSingleOrderParamsChange(): void {
    if (this.boatSingleOrderParams && this.boatSingleOrderParams.boatId !== null && this.boatSingleOrderParams.boatId !== undefined) {
      this.loadPackageServiceBalance();
    }
  }


  loadPackageServiceBalance(): void {
    if (!this.boatSingleOrderParams?.boatId) {
      this.packageServiceBalance = [];
      return;
    }

    this.loadingPackageBalance = true;

    this.packageServiceService.getPackageServiceBalanceByBoatId(this.boatSingleOrderParams.boatId).subscribe({
      next: (balance: PackageServiceBalanceDTO[]) => {
        this.packageServiceBalance = balance;
        this.loadingPackageBalance = false;

        if (balance && balance.length > 0) {
          this.checkPackageBalanceForOrderItems(balance);
        }
      },
      error: (error) => {
        this.loadingPackageBalance = false;
        this.packageServiceBalance = [];
      }
    });
  }

  restoreOriginalItemValues(): void {
    this.orderedItems = this.orderedItems.filter((item, index, array) => {
      return array.findIndex(i => i.product.id === item.product.id) === index;
    });

    this.orderedItems.forEach(item => {
      if (item.discount > 0 && item.packageBoatId) {
        item.totalValue = item.qtySupplied * item.itemValue;
        item.discount = 0;
        item.packageBoatId = undefined;
      }
    });

    this.recalculateOrderTotal();
  }

  getOriginalItemValue(item: OrderItem): number {
    if (item.product.price && item.product.price.value) {
      return item.product.price.value;
    }
    return 10.00;
  }

  checkPackageBalanceForOrderItems(balance: PackageServiceBalanceDTO[]): void {
    if (!this.orderedItems || this.orderedItems.length === 0) {
      return;
    }

    if (!balance || balance.length === 0) {
      return;
    }

    this.restoreOriginalItemValues();

    const newItems: OrderItem[] = [];
    const changesDetails: PackageChangeDetail[] = [];
    let hasChanges = false;

    this.orderedItems.forEach((orderItem, index) => {
      const packageBalance = balance.find(
        balanceItem => balanceItem.productId === orderItem.product.id
      );

      if (packageBalance && packageBalance.remainingBalance > 0) {
        const requestedQuantity = orderItem.qtySupplied;
        const availableBalance = packageBalance.remainingBalance;

        if (availableBalance >= requestedQuantity) {
          const originalValue = orderItem.totalValue || (orderItem.qtySupplied * (orderItem.itemValue || 0));
          const originalItemValue = orderItem.itemValue || 0;

          orderItem.discount = originalValue;
          orderItem.totalValue = 0;
          orderItem.packageBoatId = packageBalance.packageBoatId;

          hasChanges = true;
          changesDetails.push({
            type: 'total_discount',
            productName: orderItem.product.name,
            quantity: requestedQuantity,
            originalValue: originalValue,
            newValue: 0,
            discount: originalValue,
            message: `Desconto total aplicado - ${requestedQuantity} unidades com desconto de 100%`
          });

          packageBalance.remainingBalance -= requestedQuantity;
          packageBalance.qtdUsed += requestedQuantity;

        } else {
          const originalValue = orderItem.totalValue || (orderItem.qtySupplied * (orderItem.itemValue || 0));
          const originalQuantity = orderItem.qtySupplied;
          const originalItemValue = orderItem.itemValue || 0;

          const itemWithDiscount = { ...orderItem };
          itemWithDiscount.qtyRequested = availableBalance;
          itemWithDiscount.qtySupplied = availableBalance;
          itemWithDiscount.discount = availableBalance * originalItemValue;
          itemWithDiscount.totalValue = 0;
          itemWithDiscount.packageBoatId = packageBalance.packageBoatId;

          const itemWithoutDiscount = { ...orderItem };
          itemWithoutDiscount.qtyRequested = requestedQuantity - availableBalance;
          itemWithoutDiscount.qtySupplied = requestedQuantity - availableBalance;
          itemWithoutDiscount.discount = 0;
          itemWithoutDiscount.totalValue = itemWithoutDiscount.qtySupplied * originalItemValue;
          itemWithoutDiscount.packageBoatId = undefined;

          this.orderedItems[index] = itemWithDiscount;
          newItems.push(itemWithoutDiscount);

          hasChanges = true;
          const discountValue = availableBalance * originalItemValue;
          changesDetails.push({
            type: 'partial_discount',
            productName: orderItem.product.name,
            quantity: originalQuantity,
            originalValue: originalValue,
            newValue: itemWithoutDiscount.totalValue,
            discount: discountValue,
            freeQuantity: availableBalance,
            paidQuantity: itemWithoutDiscount.qtySupplied,
            message: `Desconto parcial aplicado - ${availableBalance} unidades com desconto, ${itemWithoutDiscount.qtySupplied} unidades sem desconto`
          });

          packageBalance.remainingBalance = 0;
          packageBalance.qtdUsed += availableBalance;
        }
      }
    });

    if (newItems.length > 0) {
      this.orderedItems.push(...newItems);
    }

    this.recalculateOrderTotal();

    if (hasChanges && changesDetails.length > 0) {
      const allProductsDetails = this.getAllProductsDetails(changesDetails);
      this.packageChangesDetails = allProductsDetails;
      this.openPackageChangesModal(allProductsDetails);
    }

  }

  getAllProductsDetails(affectedProducts: PackageChangeDetail[]): PackageChangeDetail[] {
    const allProductsDetails: PackageChangeDetail[] = [];

    allProductsDetails.push(...affectedProducts);

    this.orderedItems.forEach(orderItem => {
      const isAlreadyIncluded = affectedProducts.some(
        affected => affected.productName === orderItem.product.name
      );

      if (!isAlreadyIncluded) {
        const originalValue = orderItem.qtySupplied * (orderItem.itemValue || 0);
        const finalValue = originalValue - (orderItem.discount || 0);

        allProductsDetails.push({
          type: 'total_discount',
          productName: orderItem.product.name,
          quantity: orderItem.qtySupplied,
          originalValue: originalValue,
          newValue: finalValue,
          discount: orderItem.discount || 0,
          message: 'Produto não afetado pelo saldo de pacotes'
        });
      }
    });

    return allProductsDetails;
  }

  recalculateOrderTotal(): void {
    let newTotal = 0;
    this.orderedItems.forEach(item => {
      const itemTotal = (item.qtySupplied * item.itemValue) - (item.discount || 0);
      newTotal += itemTotal;
    });

    this.config.data.total = newTotal;
    this.total = newTotal;
  }

  openPackageChangesModal(changesDetails: PackageChangeDetail[]): void {
    const ref = this.dialogService.open(PackageBalanceChangesModalComponent, {
      header: '🎁 Descontos de Pacotes Aplicados',
      width: '1200px',
      modal: true,
      closable: true,
      draggable: false,
      resizable: false,
      data: {
        packageChangesDetails: changesDetails
      }
    });
  }



  testBoatIdChange(): void {
    const newParams = {
      customerId: this.boatSingleOrderParams?.customerId || 1,
      boatId: Math.floor(Math.random() * 100) + 1,
      slingId: this.boatSingleOrderParams?.slingId || 1,
    };
    this.boatSingleOrderParams = newParams;
  }

  updateBoatSingleOrderParams(newParams: BoatSingleOrderParams): void {
    if (this.boatSingleOrderParams && this.boatSingleOrderParams.boatId !== newParams.boatId) {
      this.previousBoatId = this.boatSingleOrderParams.boatId;
      this.boatSingleOrderParams = newParams;
      this.onBoatSingleOrderParamsChange();
    } else {
      this.boatSingleOrderParams = newParams;
    }
  }

  get isBoatIdValid(): boolean {
    return this.boatSingleOrderParams &&
           this.boatSingleOrderParams.boatId !== null &&
           this.boatSingleOrderParams.boatId !== undefined;
  }

  get currentBoatId(): number | null {
    return this.boatSingleOrderParams ? this.boatSingleOrderParams.boatId : null;
  }

  get hasPackageServiceBalance(): boolean {
    return this.packageServiceBalance && this.packageServiceBalance.length > 0;
  }

  get availablePackageBalances(): PackageServiceBalanceDTO[] {
    return this.packageServiceBalance.filter(balance => balance.remainingBalance > 0);
  }

  get boatSingleOrderParams(): BoatSingleOrderParams {
    return this._boatSingleOrderParams;
  }

  set boatSingleOrderParams(value: BoatSingleOrderParams) {
    if (this._boatSingleOrderParams && this._boatSingleOrderParams.boatId !== value.boatId) {
      this.previousBoatId = this._boatSingleOrderParams.boatId;
      this._boatSingleOrderParams = value;
      this.onBoatSingleOrderParamsChange();
    } else {
      this._boatSingleOrderParams = value;
    }
  }

  changeSelectForm() {
    this.selectedBoat = null;
    this.selectedCustomer = null;
    this.showNewCad = !this.showNewCad;
    this.isNixPix = false;
  }

  selectCustomer(event) {
    this.selectedCustomer = event.customer;
    this.selectedBoat = event.boat;
    this.validCustomerSelected = true;

    if (event.boat && event.boat.id) {
      this.boatSingleOrderParams = {
        ...this.boatSingleOrderParams,
        boatId: event.boat.id,
        customerId: event.customer ? event.customer.id : this.boatSingleOrderParams.customerId
      };
    }

    this.getTotalWithheldIssCityTax();
    if (this.boatSingleOrderParams.slingId) {
      this.continueAsCommonOrder(true);
    }
  }

  async continueAsNewCad(event?) {
    if (event == null) {
      this.simpleCadCustomer.save();
    } else {
      this.selectedCustomer = event;
      this.validCustomerSelected = true;
      this.setOrderData();
      this.updateActiveIndex(1);
    }
  }

  changeSplitItens() {
    this.orderedItems.forEach((item) => {
      item.split = this.isSplitBill;
    });
    this.splitPayments();
  }

  changePaymentForm() {
    this.showPaymentOptions = !this.showPaymentOptions;
    if (this.showPaymentOptions == false) {
      this.discount = 0;
    } else {
      this.ownersQuota = [];
    }
  }

  selectQuota(event) {
    this.ownersQuota = event;
  }

  selectDiscount(event) {
    this.discount = event.discount;
    this.pendingValue = this.getTotal();
  }

  isPayment(event) {
    this.showPaymentOptions = event;
  }

  selectPayment(event) {
    this.enablePayment = true;
    this.account = event.account;
    this.paymentMethod = event.paymentMethod;
    this.isNixPix = event.isNixPixSelected;
    this.cdr.detectChanges();
  }

  generateDocuments(invoice: any): void {
    const invoices: any[] = [];
    invoices.push(invoice);
    const countRequestDocuments = invoices.filter((i) => i.origin === 'SLING' || i.origin === 'DETACHED').length;
   // this.exit();
    if (countRequestDocuments !== 0) {
      this.router.navigate(['/app/billing/nf-emitter'], { state: { invoiceList: invoices, slingConfig: this.config.data.slingConfig } });
    } else {
      this.router.navigate(['/app/billing/nf-emitter'], { state: { invoiceList: invoices, slingConfig: this.config.data.slingConfig } });
    }
  }

  paymentComplete() {
    this.hasEnded = true;
    this.updateActiveIndex(3);
  }

  async disposeAndCancel() {
    if (!this.isError) {
      if (this.invoice) {
        await Swal.fire({
          title: 'Cancelamento',
          text: 'Deseja cancelar a fatura dessa venda?',
          icon: 'warning',
          reverseButtons: true,
          showDenyButton: true,
          customClass: {
            confirmButton: ['new-easymarine', 'primary'],
            denyButton: ['new-easymarine', 'disabled']
          },
          confirmButtonText: 'SIM',
          denyButtonText: 'NÃO',
        }).then((result) => {
          this.spinner.show();
          if (result.isConfirmed) {
            let createCopy = false;
            this.invoiceService.cancel(this.invoice.id, createCopy).subscribe({
              next: (data) => {
                this.isCanceled = true;
                this.isNixPix = false;
                this.updateActiveIndex(2);
                this.spinner.hide();
              },
              error: (error) => {
                this.isCanceled = true;
                this.isError = true;
                if (this.activeIndex == 2) {
                  this.updateActiveIndex(3);
                } else {
                  this.updateActiveIndex(2);
                }
                const exception = error.error.data.exception;
                this.messageUtil.generateMessage(MessageUtil.ERROR, exception.title, exception.message);
                this.spinner.hide();
              }
            }
            );
          }
          if (result.isDenied) {
            this.spinner.hide();
          }
        });
      } else {
        this.selectedCustomer = null;
        this.selectedBoat = null;
        this.orderedItems = [];
        this.ownersQuota = [];
        this.ownerOrderQuotas = [];
        this.discount = null;
        this.paymentMethod = null;
        this.account = null;
        this.invoice = null;
        this.issCityTax = null;
        this.total = null;
        this.showQuota = false;
        this.showPaymentOptions = false;
        this.showNewCad = false;
        this.validCustomerSelected = false;
        this.updateActiveIndex(0);
        this.isSingleOrder = false;
        this.isNixPix = false;
        this.slingConfig = null;
        this.spinner.hide();
        this.dialog.close();
      }
    } else {
      await Swal.fire({
        title: 'Cancelamento',
        text: 'Deseja ir para a tela de faturas?',
        icon: 'warning',
        reverseButtons: true,
        showDenyButton: true,
        customClass: {
          confirmButton: ['new-easymarine', 'primary'],
          denyButton: ['new-easymarine', 'disabled']
        },
        confirmButtonText: 'SIM',
        denyButtonText: 'NÃO',
      }).then((result) => {
        if (result.isConfirmed) {
          this.router.navigate(['/app/billing/invoice']);
          this.dialog.close();
        }
        if (result.isDenied) {
          this.exit()
        }
      });
    }
  }

  async continueAsCommonOrder(fromSling?: boolean) {

    if (this.getOwnersCount() > 1 && !fromSling) {
      this.showQuota = true;
    } else {
      this.showQuota = false;
    }

    this.setOrderData();
    this.updateActiveIndex(1);
  }

  setOrderData() {
    this.salesStatesService.setOrderData({
      orderedItems: this.config.data.orderedItems,
      slingConfig: this.config.data.slingConfig,
      selectedCustomer: this.selectedCustomer,
      serviceDeskCustomer: this.serviceDeskCustomer,
      selectedBoat: this.selectedBoat,
      total: this.config.data.total,
      hasInvoice: this.invoice != null,
      discountedValue: this.discount,
    });
  }

  findServiceDeskCustomer() {
    this.customerService.getByServiceDeskCustomer().subscribe((data) => {
      this.serviceDeskCustomer = data;
    });
  }

  continueAsSingleOrder() {
    this.customers = [];
    this.selectedCustomer = null;
    this.selectedBoat = null;
    this.findServiceDeskCustomer();
    this.setOrderData();
    this.showPaymentOptions = true;
    this.isSingleOrder = true;
    this.updateActiveIndex(1);
  }

  finishRequest(): void {
    this.save(null);
  }


  getOwnersCount(): number {
    let count = 0;
    if (this.selectedBoat) {
      for (const boat of this.selectedBoat.boatCustomers) {
        if (boat.type === 'Owner') {
          count++;
        }
      }
    }
    return count;
  }

  save(data): void {
    let text = '';
    if (data) {
      if (this.isNixPix || this.isSplitBill) {
        text = `Faturamento de ${CurrencyUtil.formatCurrency(this.getTotal(), this.currentCurrency)}`;
      } else {
        text = `Pagamento de ${CurrencyUtil.formatCurrency(this.pendingValue, this.currentCurrency)}`;
      }
    } else {
      text = `Gerar Pedido de ${CurrencyUtil.formatCurrency(this.getTotal(), this.currentCurrency)}`;
    }
    Swal.fire({
      title: 'Confirmar operação?',
      text: text,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      showLoaderOnConfirm: true,
      reverseButtons: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      allowOutsideClick: false,
      preConfirm: () => {
        this.spinner.show();
        console.log(data);
        if (this.sling?.id) {
          this.slingSave();
        } else {
          this.createSingleOrder(data);
        }
      }
    }).then((result) => {
      if (!result.isConfirmed) {
        this.spinner.hide();
      }
    });
  }

  payGeneratedInvoice(data: any, parcial: boolean) {
    if (this.invoice == null || parcial) {
      let text = '';
      if (this.isNixPix || this.isSplitBill) {
        text = `Faturamento de ${CurrencyUtil.formatCurrency(this.invoice.pendingValue, this.currentCurrency)}`;
      } else {
        text = `Pagamento de ${CurrencyUtil.formatCurrency(this.pendingValue, this.currentCurrency)}`;
      }
      Swal.fire({
        title: 'Confirmar operação?',
        text: text,
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        showLoaderOnConfirm: true,
        reverseButtons: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        allowOutsideClick: false,
        preConfirm: () => {
          this.spinner.show();
          this.createInvoicePaid(data);
        }
      }).then((result) => {
        if (!result.isConfirmed) {
          this.spinner.hide();
        }
      });
    } else {
      this.spinner.show();
      this.createInvoicePaid(data);
    }
  }

  createInvoicePaid(data: any) {
    let employeeUser = StorageUtil.getUser();
    const invoicePaid: InvoicePaid = new InvoicePaid();

    invoicePaid.discount = this.invoice.discount;
    invoicePaid.interest = this.invoice.interest;
    invoicePaid.value = this.invoice.value;
    invoicePaid.username = this.invoice.customer.name;
    invoicePaid.employeeUser = employeeUser.firstName + " " + employeeUser.lastName;
    invoicePaid.invoiceId = this.invoice.id;
    invoicePaid.totalPaid = this.pendingValue;
    invoicePaid.dateProcessing = this.invoice.processingDate;
    invoicePaid.datepaid = new Date();

    invoicePaid.accountId = data.account.idConta;
    invoicePaid.accountName = data.account.nome;
    invoicePaid.paymentMethodId = data.paymentMethod.idTipoFormaPagamento;
    invoicePaid.paymentMethodName = data.paymentMethod.descricao;

    this.invoicePaidService.payInvoice(invoicePaid).subscribe({
      next: (data) => {
        if (this.isFirstDiscount) {
          this.isFirstDiscount = false;
          this.maxPendingValue -= this.discount;
        }
        this.maxPendingValue -= this.pendingValue;
        if (this.maxPendingValue > 0) {
          this.pendingValue = this.maxPendingValue;
                     this.messageUtil.generateMessage(MessageUtil.SUCCESS, 'Faturamento', `Pagamento realizado com sucesso, faltam ${CurrencyUtil.formatCurrency(this.pendingValue, this.currentCurrency)} para quitar a fatura.`);
          this.setOrderData();
          this.spinner.hide();
        } else {
          this.spinner.hide();
          if (this.slingConfig.printNavigationPlanWeb == OptionPrintQuestionTotem.Question) {
            Swal.fire({
              title: 'Atenção',
              text: 'Deseja imprimir o recibo de pagamento?',
              icon: 'warning',
              reverseButtons: true,
              showDenyButton: true,
              customClass: {
                confirmButton: ['new-easymarine', 'primary'],
                denyButton: ['new-easymarine', 'disabled']
              },
              confirmButtonText: 'SIM',
              denyButtonText: 'NÃO',
            }).then(async (result) => {
              if (result.isConfirmed) {
                await this.printReceipt(this.invoice.id);
                this.updateActiveIndex(2);
              } else {
                this.updateActiveIndex(2);
              }
            });
          }
          if (this.slingConfig.printNavigationPlanWeb == OptionPrintQuestionTotem.AutoPrint) {
            this.printReceipt(this.invoice.id);
            this.updateActiveIndex(2);
          }
          if (this.slingConfig.printNavigationPlanWeb == OptionPrintQuestionTotem.NoAction) {
            this.updateActiveIndex(2);
          }
        }
      },
      error: (error) => {
        const exception = error.error.data.exception;
        this.messageUtil.generateMessage(MessageUtil.ERROR, exception.title, exception.message);
        this.spinner.hide();
      }
    }
    );
  }

  slingSave(): void {
    const items = this.sling.marinaOrder.orderItems.filter(
      (item) => item.product.productCategory.productCategoryType !== ProductCategoryType.Consumable
    );
    this.config.data.orderedItems.forEach((item) => items.push(item));
    this.sling.marinaOrder.orderItems = items;

    this.slingService.save(this.sling).subscribe(() => {
      this.toasty.success('Pedido salvo com sucesso.');
      this.exit();
    },
      (error) => {
        const exception = error.error.data.exception;
        this.messageUtil.generateMessage(MessageUtil.ERROR, exception.title, exception.message);
      }
    );
  }

  exit(): void {
    this.dialog.close();
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/single-order']);
    });

  }

  createSingleOrder(account): void {
    this.convertOwnerQuota();
    const marinaOrder: MarinaOrder = this.createMarinaOrder(account);
    this.marinaOrderService.createSingleOrder(marinaOrder).subscribe({
      next: (marinaOrderSave) => {
        if (account != null) {
          this.findInvoice(marinaOrderSave);
        } else {
          this.updateActiveIndex(2);
          this.orderNumber = marinaOrderSave.orderNumber;
          if (this.slingConfig.printNavigationPlanWeb == OptionPrintQuestionTotem.Question) {
            Swal.fire({
              title: 'Atenção',
              text: 'Deseja imprimir a Comanda?',
              icon: 'warning',
              reverseButtons: true,
              showDenyButton: true,
              customClass: {
                confirmButton: ['new-easymarine', 'primary'],
                denyButton: ['new-easymarine', 'disabled']
              },
              confirmButtonText: 'SIM',
              denyButtonText: 'NÃO',
            }).then(async (result) => {
              if (result.isConfirmed) {
                await this.printOrderReport(marinaOrderSave.id);
              }
              if (result.isDenied || result.isDismissed) {
              }
            });
          }
          if (this.slingConfig.printNavigationPlanWeb == OptionPrintQuestionTotem.AutoPrint) {
            this.printOrderReport(marinaOrderSave.id);
          }
          this.spinner.hide();
        }
      },
      error: (error) => {
        const exception = error.error.data.exception;
        this.messageUtil.generateMessage(MessageUtil.ERROR, exception.title, exception.message);
        this.spinner.hide();
      }
    });
  }

  convertOwnerQuota(): void {
    this.ownerOrderQuotas = [];
    if (this.ownersQuota?.length > 0) {
      for (const owner of this.ownersQuota) {
        const quota: OrderQuota = new OrderQuota();
        quota.customer = owner.customer;
        quota.quota = owner.singleOrderQuota;
        if (quota.quota > 0) {
          this.ownerOrderQuotas.push(quota);
        }
      }
    } else {
      const quota: OrderQuota = new OrderQuota();
      quota.customer = this.selectedCustomer != null ? this.selectedCustomer : this.serviceDeskCustomer;
      quota.quota = 100;
      this.ownerOrderQuotas.push(quota);

    }
  }

  createMarinaOrder(data): MarinaOrder {
    const marinaOrder = new MarinaOrder();
    marinaOrder.customer = this.selectedCustomer;
   // marinaOrder.orderItems = this.config.data.orderedItems;
    marinaOrder.orderItems = this.orderedItems;
    console.log(marinaOrder.orderItems);
    marinaOrder.orderQuotas = this.ownerOrderQuotas;
    if (data) {
      marinaOrder.paymentMethodId = data.paymentMethod?.idTipoFormaPagamento ?? this.standardPaymentConfig.paymentMethodId;
      marinaOrder.paymentMethodName = data.paymentMethod?.descricao ?? this.standardPaymentConfig.paymentMethodName;
      marinaOrder.accountId = data.account?.idConta ?? this.standardPaymentConfig.accountId;
      marinaOrder.accountName = data.account?.nome ?? this.standardPaymentConfig.accountName;
      marinaOrder.discount = data.discount;
      marinaOrder.cashDown = 1;
      marinaOrder.pay = data.pay;
    }
    marinaOrder.lastEmployeeName = StorageUtil.getUserName();
    marinaOrder.orderDate = null;
    marinaOrder.value = this.config.data.total;
    marinaOrder.boat = this.selectedBoat;
    marinaOrder.sling = null;
     marinaOrder.marina = null;
     marinaOrder.orderObs = this.observation;
    if (this.pendingValue != this.getTotal()) {
      marinaOrder.pay = false;
    }
    return marinaOrder;
  }

  findInvoice(marinaOrder): void {
    this.invoiceService.findByOrder(marinaOrder.id).subscribe({
      next: (data) => {
        if (data.length !== 0) {
          this.invoice = data[0];
          this.invoice.paidValue = data[0].totalPaid;
          if (this.invoice) {
            if (this.isNixPix) {
              this.spinner.hide();
              this.subscribeToWebStocket();
            }
            if (this.invoice.pendingValue > 0) {
              this.payFinishRequest(false);
            } else {
              this.spinner.hide();
              if (this.slingConfig.printNavigationPlanWeb == OptionPrintQuestionTotem.Question) {
                Swal.fire({
                  title: 'Atenção',
                  text: 'Deseja imprimir o recibo de pagamento?',
                  icon: 'warning',
                  reverseButtons: true,
                  showDenyButton: true,
                  customClass: {
                    confirmButton: ['new-easymarine', 'primary'],
                    denyButton: ['new-easymarine', 'disabled']
                  },
                  confirmButtonText: 'SIM',
                  denyButtonText: 'NÃO',
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    await this.printReceipt(this.invoice.id);
                    this.updateActiveIndex(2);
                  } else {
                    this.updateActiveIndex(2);
                  }
                });
              }
              if (this.slingConfig.printNavigationPlanWeb == OptionPrintQuestionTotem.AutoPrint) {
                this.printReceipt(this.invoice.id);
                this.updateActiveIndex(2);
              }
              if (this.slingConfig.printNavigationPlanWeb == OptionPrintQuestionTotem.NoAction) {
                this.updateActiveIndex(2);
              }
            }
          } else {
            this.spinner.hide();
            this.exit();
          }
        }
      },
      error: (error) => {
        const exception = error.error.data.exception;
        this.messageUtil.generateMessage(MessageUtil.ERROR, exception.title, exception.message);
      }
    }
    );
  }

  splitPayments() {
    let total = this.calculateTotalItems();
    let totalSplited = 0;
    this.orderedItems.forEach((item: any) => {
      if (item.split) {
        totalSplited = totalSplited + (item.itemValue * item.qtySupplied);
      }
    });
    let equalParts = totalSplited / 2;
    let notSplitedPart = total - totalSplited;
    let notSplitedPlusEqualParts = notSplitedPart + equalParts;

    this.payments = [];
    let validTotal = 0
    for (let i = 0; i < 2; i++) {
      this.payments.push({
        id: i + 1,
        customer: `Customer ${i + 1}`,
        split: equalParts,
        total: i == 0 ? notSplitedPlusEqualParts : equalParts,
        numberOfCustomers: 2,
        totalSplited: totalSplited,
        notSplitedPart: notSplitedPart,
        totalTotal: total,
      });
      validTotal += this.payments[i].total;
    }
    if (validTotal !== total) {
      this.payments[0].total += total - validTotal;
    }

    this.salesStatesService.setPayments(this.payments);
  }

  async payFinishRequest(parcial: boolean): Promise<void> {
    const data = ({
      slingConfig: this.slingConfig,
      issCityTax: this.issCityTaxValue,
      orderedItems: this.orderedItems,
      selectedCustomer: this.selectedCustomer,
      serviceDeskCustomer: this.serviceDeskCustomer,
      paymentMethod: this.paymentMethod,
      account: this.account,
      discount: this.discount,
      total: this.total,
      pay: this.isNixPix || this.isSplitBill ? false : true,
    });

    if (this.invoice != null) {
      if (this.isSplitBill) {
        this.salesStatesService.setInvoice(this.invoice);
        this.updateActiveIndex(2);
      } else if (this.isNixPix) {
        this.subscribeToWebStocket()
        this.updateActiveIndex(2);
      } else {
        this.payGeneratedInvoice(data, parcial);
      }
    } else {
      this.save(data);
    }
  }

  getTotalWithheldIssCityTax() {
    if (this.selectedCustomer != null) {
      this.convertOwnerQuota();
      let issTaxRequest: OrderIssCityTaxRequestDTO = {
        customerId: this.selectedCustomer.id,
        order: this.createMarinaOrder(null)
      };

      this.marinaOrderService.getWhitheldIssTaxByOrder(issTaxRequest).subscribe({
        next: async (data) => {
          this.issCityTaxValue = data;
          if (this.isFirstIssCityTax) {
            this.isFirstIssCityTax = false;
            this.pendingValue -= this.issCityTaxValue ?? 0;
            this.maxPendingValue -= this.issCityTaxValue ?? 0;
          }
        },
        error: (error) => {
          const exception = error.error.data.exception;
          this.messageUtil.generateMessage(MessageUtil.ERROR, exception.title, exception.message);
        }
      }
      );
    }
    this.setOrderData();
  }

  getTotal(): number {
    let total = 0;
    total += this.total;

    if (this.showPaymentOptions) {
      total -= this.issCityTax ? this.issCityTaxValue : 0;
      total -= this.discount ? this.discount : 0;
    }

    return total;
  }

  formatNumber(number: number): string {
    return number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  getCurrencyPrefix(): string {
    return CurrencyUtil.getCurrencySymbol(this.currentCurrency) + ' ';
  }

  validToIssueNf(invoice: any): boolean {
    const orderItens: any[] = invoice.orders[0].orderItems;
    if (orderItens != null && orderItens.length > 0) {
      orderItens.forEach((item) => {
        if (item.productissueNotaFiscal == true) {
          return true;
        }
      });
    }
    return false;
  }

  updateActiveIndex(index: number) {
    this.spinner.hide();
    this.activeIndex = index;
  }

  subscribeToWebStocket() {
    this.webSocketService.getMessageNixPix(this.invoice.id).subscribe({
      next: (message) => {
        if (message.headers !== null && message.headers.destination !== null && message.headers.destination !== '') {
          const queryParts = message.headers.destination.split('/');
          if (queryParts.length >= 3) {
            const invoiceId = queryParts[2];
            if (invoiceId == this.invoice.id.toString()) {
              this.updateActiveIndex(3);
            }
          }
        }
      },
      error: (e) => console.log(e),
    });
  }

  async back() {
    this.setOrderData()
    this.updateActiveIndex(1);
    this.showPaymentOptions = true;
  }


  continueAsSplitBill() {
    this.isNixPix = false;
    this.spinner.show();
    this.payFinishRequest(true);
  }

  validateSplitBillItems() {
    this.validSplitBillItems = false;
    this.orderedItems.forEach((item) => {
      if (item.split) {
        this.validSplitBillItems = true;
        return;
      }
    });
    this.splitPayments();
  }

  calculateTotalItems() {
    let itemTotal = 0;
    this.orderedItems.forEach((item) => {
      itemTotal += (item.qtySupplied * item.itemValue) - item.discount || 0 ;
    });
    return itemTotal;
  }

  generateNfc() {
    this.spinner.show();
    const newInvoiceId = this.invoice.id;
    if (newInvoiceId === null) {
      this.spinner.hide();
      return;
    }
    this.notaFiscalService.generateNFConsumidor(newInvoiceId).subscribe({
      next: (data) => {
        console.log("Retornou a nota fiscal!!!")
        console.log(data)
        this.spinner.hide();
        this.documentUrl = data.caminho_danfe;
        this.showSuccessModal = true;
      }, error: (err) => {
        this.spinner.hide();
        console.log(err)
        const exception = err.error.message;
        this.toasty.error(exception)
      }
    })
  }

  printReceipt(invoicePaidId: number): void {
    this.spinner.show();
    this.printingService.generatePdfById(invoicePaidId, PrintType.RECEIPT).subscribe((data) => {
      this.spinner.hide();
      const url = window.URL.createObjectURL(data);
      window.open(url);
    });
  }

  printOrderReport(id: number): void {
    this.spinner.show();
    const idsSling: number[] = [id];
    this.printingService.generatePdfById(id, PrintType.ORDER_CHECK).subscribe((data) => {
      this.spinner.hide();
      const url = window.URL.createObjectURL(data);
      window.open(url);
    });
  }

  closeSuccessModal(): void {
    this.showSuccessModal = false;
  }

  printDocument(): void {
    if (this.documentUrl) {
      window.open(this.documentUrl);
    }
    this.closeSuccessModal();
  }

  sendWhatsApp(): void {
    console.log(this.invoice);

    const sendWhatsAppMessage = (phoneNumber: string) => {
      const re = /(\(|\)|-)/gi;
      const cleanPhoneNumber = phoneNumber.replace(re, '').replace(' ', '');
      const marina = StorageUtil.getMarinaName();

      const msg = `Olá ${this.invoice?.customer?.name}, segue o seu cupom fiscal da ${this.slingConfig?.marina?.companyName}.\n\nCupom Fiscal: ${this.documentUrl}`;

      const uriMessage = encodeURIComponent(msg);
      const path = `https://api.whatsapp.com/send/?phone=${cleanPhoneNumber}&text=${uriMessage}&app_absent=0`;

      window.open(path);
      this.closeSuccessModal();
    };

    const isBalcao = this.invoice?.customer?.name?.toLowerCase().includes('balcão') ||
                     this.invoice?.customer?.name?.toLowerCase().includes('balcao');

    if (this.invoice?.customer?.phone && !isBalcao) {
      sendWhatsAppMessage(this.invoice.customer.phone);
    } else {
      Swal.fire({
        title: 'Digite o número do WhatsApp',
        input: 'text',
        inputPlaceholder: 'Ex: 11999999999',
        inputAttributes: {
          'aria-label': 'Digite o número do WhatsApp'
        },
        showCancelButton: true,
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#25D366',
        inputValidator: (value) => {
          if (!value) {
            return 'Por favor, digite um número de telefone!';
          }
          if (!/^\d{10,11}$/.test(value.replace(/\D/g, ''))) {
            return 'Por favor, digite um número válido (10 ou 11 dígitos)!';
          }
        }
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          sendWhatsAppMessage(result.value);
        }
      });
    }
  }

  sendEmail(): void {
    const sendEmailMessage = (email: string) => {
      const originalEmail = this.invoice?.customer?.email;
      this.invoice.customer.email = email;

      this.send(this.invoice).then(() => {
        this.invoice.customer.email = originalEmail;
      });
    };

    if (this.invoice?.customer?.email) {
      sendEmailMessage(this.invoice.customer.email);
    } else {
      Swal.fire({
        title: 'Digite o e-mail do cliente',
        input: 'email',
        inputPlaceholder: 'Ex: cliente@email.com',
        inputAttributes: {
          'aria-label': 'Digite o e-mail do cliente'
        },
        showCancelButton: true,
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        inputValidator: (value) => {
          if (!value) {
            return 'Por favor, digite um e-mail!';
          }
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            return 'Por favor, digite um e-mail válido!';
          }
        }
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          sendEmailMessage(result.value);
        }
      });
    }
  }

  async confirmInvoiceToSend(): Promise<boolean> {
    return Swal.fire(
      {
        title: 'Será realizado o envio de e-mail da nota para o email' + this.invoice?.customer?.email + '<br> Deseja continuar?',
        icon: 'warning',
        showCancelButton: true,
        backdrop: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      }).then((res) => res.isConfirmed );
  }

  private async send(body: any): Promise<void> {
    const confirm = await this.confirmInvoiceToSend();
    if (confirm) {
      this.spinner.show();
      const attachments: InvoiceEmailAttachmentType[] = [InvoiceEmailAttachmentType.Nfc];
      this.invoiceService.sendEmails(body, attachments).subscribe(
        () => {
          this.messageUtil.generateMessage('success', 'SUMMARY.SUCCESS', 'MSG.SENT-EMAILS');
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          const exception = error.error.data.exception;
          this.messageUtil.generateMessage(exception.type, exception.title, exception.message);
        }
      );
    } else {
    }
  }
}
